import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { ErrorOutlineIcon, IconsFill } from 'src/svgs/Viagogo';

import * as styles from './MessageWithIcon.css';

export const FailureMessage = ({
  message,
}: {
  message: string | JSX.Element;
}) => {
  return (
    <Stack direction="row" gap="m" className={styles.messageContainer}>
      <ErrorOutlineIcon fill={IconsFill.textNegative} size={vars.iconSize.l} />
      <div className={styles.messageDiv}>{message}</div>
    </Stack>
  );
};
